import axios from './axios'

/**
 * Bff 聚合接口请求, 不支持加密接口
 * @param {Array} reqList 示例如下
```js
[{
  // 接口参数
  uri: '',
  httpMethod: 'GET', // 请求接口的方法，默认是 GET
  parameters: {}, // http params 参数
  body: {}, // http body 参数
  // 自定义参数
  callback: () => {},  // 接口响应数据回调
  self: false, // 是否直接解析 bizCode === 10000 对应 data, 为 true 时不解析
  onError: () => {} // self === false 时 bizCode !=== 10000 时调用
}]
```
 * @returns
 */
export default async function fetchBff(reqList = []) {
  const callbackList = []
  const body = []
  reqList.forEach((x) => {
    const { callback, self, onError, ...restParams } = x
    callbackList.push({ callback, self, onError })
    body.push(restParams)
  })
  const res = await axios.post('/bff', body, { self: true })
  callbackList.forEach((item, index) => {
    const { callback, self, onError } = item
    const response = res[index]
    if (callback) {
      if (self) {
        // response
        callback(response)
      } else {
        const { bizCode, data, message } = response
        if (bizCode === 10000) {
          // success response
          callback(data)
        } else {
          // error response
          onError && onError({ bizCode, message })
        }
      }
    }
  })
  callbackList.length = 0
  body.length = 0
  return res
}
